export const SEARCH_PAGE_RESULTS_PAGE_SIZE = 12;
export const SEARCH_DIALOG_RESULTS_PAGE_SIZE = 5;
export const SEARCH_DIALOG_RESULTS_CACHE_KEY = 'search-dialog-results';
export const SEARCH_PAGE_RESULTS_CACHE_KEY = 'search-results';
